import {H1} from '@jetbrains/ring-ui/components/heading/heading'
import Icon from '@jetbrains/ring-ui/components/icon'

import SpaceIcon from '../../../../../svg/space.svg'
import GitHubIcon from '../../svg/github.svg'
import {isSpaceConnectionEnabled} from '../../utils/featureToggles'

import styles from './CreatePipelineHeader.css'

function CreatePipelineHeader() {
  return (
    <div className={styles.header}>
      <div className={styles.heading}>
        <H1 className={styles.title}>{'Create Pipeline'}</H1>
        <div className={styles.vcs}>
          <Icon
            glyph={isSpaceConnectionEnabled ? SpaceIcon : GitHubIcon}
            className={styles.vcsIcon}
          />
          <span className={styles.vcsText}>{`Choose repository from ${
            isSpaceConnectionEnabled ? 'Space' : 'GitHub'
          }`}</span>
        </div>
      </div>
    </div>
  )
}

export default CreatePipelineHeader
